module.exports = __webpack_public_path__ + "img/trivia-success.d761f1a9.svg";